import React from 'react';

import { Chip, ChipProps } from '@infoods/lifebase-ui';
import { GridTableCell } from '../../../../../shared/components/table-components';
import { ReleaseStatusType, RELEASE_STATUS } from '../../../../constants/releaseStatus';
import { getHumanizeReleaseStatus } from '../../../../utils/getHumanizeReleaseStatus/getHumanizeReleaseStatus';

type ReleaseStatusCellProps = {
  status: ReleaseStatusType;
};
const chipColor: Record<ReleaseStatusType, ChipProps['color']> = {
  [RELEASE_STATUS.UPCOMING]: 'warning',
  [RELEASE_STATUS.RELEASED]: 'success',
};

const ReleaseStatusCell = ({ status }: ReleaseStatusCellProps) => {
  return (
    <GridTableCell>
      <Chip
        size="small"
        color={chipColor[status]}
        label={getHumanizeReleaseStatus(status)}
      />
    </GridTableCell>
  );
};

export { ReleaseStatusCell };
